/*!
=========================================================
* Muse Ant Design Dashboard - v1.0.0
=========================================================
* Product Page: https://www.creative-tim.com/product/muse-ant-design-dashboard
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/muse-ant-design-dashboard/blob/main/LICENSE.md)
* Coded by Creative Tim
=========================================================
* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { Provider } from "react-redux";
import { store } from "./redux/store"; // Assurez-vous que ce chemin est correct
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// --- CONFIGURATION ANT DESIGN LOCALE ---
import { ConfigProvider } from 'antd';
// Chemin ajusté pour Antd v5+ (utiliser directement le package)
import frFR from 'antd/locale/fr_FR'; // <<< Importer la locale Ant Design Français (nouveau chemin)

// --- CONFIGURATION DAYJS LOCALE ---
import dayjs from 'dayjs';
import 'dayjs/locale/fr'; // <<< Importer la locale française pour dayjs
dayjs.locale('fr'); // <<< Appliquer la locale française globalement pour dayjs
// --- FIN CONFIGURATIONS ---

ReactDOM.render(
  // StrictMode est recommandé mais peut être retiré si vous avez des problèmes avec d'anciennes librairies
  <React.StrictMode>
    <Provider store={store}>
      {/* Envelopper l'application avec ConfigProvider et passer la locale */}
      <ConfigProvider locale={frFR}>
        <BrowserRouter>
          <ToastContainer /> {/* Placer ToastContainer à l'intérieur ou à l'extérieur de BrowserRouter selon préférences */}
          <App />
        </BrowserRouter>
      </ConfigProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);